export default __webpack_public_path__ + "static/media/referralCreativeNew.c4843961.svg";